<template>
  <router-link :to="backLink">
    <button
      class="inline-flex font-roboto pr-4 py-2 px-2 text-blue-700 rounded hover:text-white hover:bg-blue-900"
      :iconOnly="false"
    >
      <i-heroicons-outline-arrow-left class="h-4 w-5 mx-1 mt-1" />
      <slot></slot>
    </button>
  </router-link>
</template>

<script lang="ts" setup>
let props = withDefaults(
  defineProps<{
    to?: string;
  }>(),
  {
    to: "#",
  }
);

let backLink = computed(() => {
  let route = useRouter()?.currentRoute?.value?.fullPath;
  let target = props.to?.toString() ?? "";
  if (route?.length > 0 && target.endsWith("..")) {
    //  ".." = move up one folder
    return route.substring(0, route.lastIndexOf("/"));
  }
  return props.to;
});
</script>
